let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jwEps")).then(() => parcelRequire('4deUn'));